import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/montserrat"; // poids 400 par défaut
import "@fontsource/montserrat/500.css"; // autres poids
import "@fontsource/montserrat/700.css";
import ReactGA from 'react-ga4';
import i18n from './i18n';
import { BrowserRouter } from 'react-router-dom';


// Initialisation de Google Analytics 4
ReactGA.initialize("G-WFGKQYLJ48");

// *** Ajoutez cette ligne pour activer les événements automatiques ***
// Cela dit à GA4 de commencer à écouter les clics sortants, scrolls, etc.
ReactGA.gtag('config', 'G-WFGKQYLJ48', {
  'send_page_view': false // On désactive la vue de page ici, car notre hook la gère déjà
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
